import { Box, Stack } from "@mui/joy";
import React from "react";
import Logo from "assets/Logo2";
import Link from "components/common/Link";
import { useTranslation } from "react-i18next";
import useGetUrls from "hooks/useGetUrls";

export default function DefaultPage({ content }: { content: React.ReactNode }) {
  const { t: t_ui } = useTranslation("translation", {
    keyPrefix: "ui",
  });
  const { companyInfoUrl, privacyPolicyUrl, servicePolicyUrl } = useGetUrls();
  return (
    <Stack
      direction={"column"}
      alignItems="center"
      sx={{
        zIndex: 1000,
        position: "fixed",
        top: 0,
        width: "100vw",
        height: "calc(var(--vh,1vh) * 100)",
        minHeight: "calc(var(--vh,1vh) * 100)",
        backgroundColor: "background.level1",
        py: "40px",
      }}
    >
      <Box>
        <Box className="scale-[1.5]">
          <Logo />
        </Box>
      </Box>
      <Stack
        flexGrow={1}
        justifyContent="center"
        sx={{ width: "100%", px: "20px" }}
      >
        {content}
      </Stack>
      {/* <Box sx={{ px: 5, wordBreak: "keep-all" }}>
        <Typography level="body-xs" textAlign={"center"} sx={{ opacity: 0.2 }}>
          주식회사 오웰헬스
          <br /> 대표 홍승주 | 사업자등록번호 378-86-02282 | 통신판매업신고 제
          2022-서울강남-02138
          <br /> 서울특별시 강남구 역삼로 168, 202호 (역삼동, 회성빌딩)
          070-7954-3518
        </Typography>
      </Box> */}

      <Stack
        direction={"row"}
        spacing={1}
        sx={{ pt: 1, wordBreak: "keep-all" }}
      >
        <Link text={t_ui("사업자 정보")} url={companyInfoUrl} />
        <Link text={t_ui("(대) 개인정보 처리방침")} url={privacyPolicyUrl} />
        <Link text={t_ui("(대) 서비스 이용약관")} url={servicePolicyUrl} />
      </Stack>
    </Stack>
  );
}
